"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Customer = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Customer = ({
  size = 22,
  width = size,
  height = size,
  fill = '#121213',
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 14 22",
  fill: fill,
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.9779 2.23869C10.9779 3.36506 10.0711 4.27817 8.95237 4.27817C7.83368 4.27817 6.9268 3.36506 6.9268 2.23869C6.9268 1.11232 7.83368 0.199219 8.95237 0.199219C10.0711 0.199219 10.9779 1.11232 10.9779 2.23869ZM17.0546 13.6597C17.0546 14.7861 16.1478 15.6992 15.0291 15.6992C13.9104 15.6992 13.0035 14.7861 13.0035 13.6597C13.0035 12.5334 13.9104 11.6203 15.0291 11.6203C16.1478 11.6203 17.0546 12.5334 17.0546 13.6597ZM10.9779 9.5808C10.9779 10.7072 10.0711 11.6203 8.95237 11.6203C7.83368 11.6203 6.9268 10.7072 6.9268 9.5808C6.9268 8.45443 7.83368 7.54132 8.95237 7.54132C10.0711 7.54132 10.9779 8.45443 10.9779 9.5808ZM4.90123 13.6597C4.90123 14.7861 3.99436 15.6992 2.87567 15.6992C1.75698 15.6992 0.850098 14.7861 0.850098 13.6597C0.850098 12.5334 1.75698 11.6203 2.87567 11.6203C3.99436 11.6203 4.90123 12.5334 4.90123 13.6597Z",
  fill: "#121213"
}));

exports.Customer = Customer;